var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "footerCon" },
    [_vm._t("cleaner"), _vm._v(" "), _vm._t("footer")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }